/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { useWelcomePage } from '../WelcomePage/utils/useWelcomePage';

function Vanity({ className }) {
  const { loginTitle, registerTitle } = useWelcomePage();

  return (
    <div className="dtv-html5-c-vanity">
      <div className={`dtv-html5-c-vanity__title ${className}`}>
        <p>{ loginTitle }</p>
        <p>{ registerTitle }</p>
      </div>
    </div>
  );
}

Vanity.propTypes = {
  className: PropTypes.string,
};

Vanity.defaultProps = {
  className: '',
};

export default memo(Vanity);
